<div class="mx-2 p-2 pb-5">
  <form [formGroup]="taskDetailForm" class="mt-2">
    <div class="row px-4">
      <div class="col-12 col-md-8">
        <div class="row pb-1">
          <div class="col-12 col-sm-2 label-text"><label>Description</label></div>
          <div class="col-12 col-sm-10">
            <input class="form-control" formControlName="summary" maxlength="80"/>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="row pb-1">
          <div class="col-12 col-sm-6 col-md-4 label-text"><label>High priority</label></div>
          <div class="col-12 col-sm-6 col-md-8">
            <input type="checkbox" class="form-check-input" formControlName="priority" />
          </div>
        </div>
      </div>
    </div>

    <div class="row p-2 px-4">
      <div class="col-12 col-md-4 pb-1">
        <div class="row pb-1">
          <div class="col-12 col-sm-4 label-text"><label>Due Date</label></div>
          <div class="col-12 col-sm-6">
            <div class="input-group row mx-0 px-0">
              <input class="form-control" ngbDatepicker #d1="ngbDatepicker" formControlName="dueDate" (dateSelect)="onDueDateSelected($event)" />
              <button class="btn btn-secondary calendar text-white px-2 py-3" (click)="d1.toggle()" type="button"></button>
            </div>
            <span *ngIf="this.taskDetailForm.get('dueDate').value && this.taskDetailForm.get('dueDate').invalid" class="text-danger">
              (Invalid Date)
            </span>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 pb-1">
        <div class="row pb-1">
          <div class="col-12 col-sm-4 label-text"><label>Assigned site</label></div>
          <div class="col-12 col-sm-8">
            <input #siteInput class="form-control" [readOnly]="!newTask" (focus)="changeAssigneeCheck()" formControlName="siteDescription" />
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 pb-1">
        <div class="row pb-1">
          <div class="col-12 col-sm-4 label-text"><label>Assigned To</label></div>
          <div class="col-12 col-sm-8">
            <input
              *ngIf="!newTask"
              #assignedToInput
              class="form-control"
              [readOnly]="!newTask"
              (focus)="changeAssigneeCheck()"
              formControlName="assignedTo"
            />
            <input
              *ngIf="newTask"
              #assignedToInput
              class="form-control"
              [readOnly]="newTask"
              (focus)="changeAssigneeCheck()"
              formControlName="assignedToName"
            />
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!newTask" class="row px-4">
      <div class="col-12 col-md-4 pb-1">
        <div class="row pb-1">
          <div class="col-12 col-sm-4 label-text"><label>Date Created</label></div>
          <div class="col-12 col-sm-8">
            <input class="form-control" [readOnly]="true" formControlName="createDate" />
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 pb-1">
        <div class="row pb-1">
          <div class="col-12 col-sm-4 label-text"><label>Source site</label></div>
          <div class="col-12 col-sm-8">
            <input class="form-control" [readOnly]="true" formControlName="site" />
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 pb-1">
        <div class="row pb-1">
          <div class="col-12 col-sm-4 label-text"><label>Raised by</label></div>
          <div class="col-12 col-sm-8">
            <input class="form-control" [readOnly]="true" formControlName="RaisedBy" />
          </div>
        </div>
      </div>
    </div>

    <div class="row px-4">
      <div class="col-12 col-md-4 pb-1">
        <div class="row pb-1">
          <div class="col-12 col-sm-4 label-text">
            <label>Linked Order</label>
            <span
              *ngIf="taskDetailForm?.value?.orderNumber && taskDetailForm?.value?.orderNumber > 0"
              title="Load order into staging"
              style="float: right"
              (click)="fetchOrderFromJDE()"
              ><mat-icon>refresh</mat-icon></span
            >
          </div>
          <div class="col-12 col-sm-8">
            <input #orderInput class="form-control" [readOnly]="!newTask" formControlName="orderNumber" (focus)="changeOrderCheck()" />
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 pb-1">
        <div class="row pb-1">
          <div class="col-12 col-sm-4 label-text"><label>Status</label></div>
          <div class="col-12 col-sm-8">
            <input class="form-control" [readOnly]="true" formControlName="status" />
          </div>
        </div>
      </div>

      <div class="col-12 col-md-4 pb-1">
        <div class="row pb-1">
          <div class="col-12 col-sm-4 label-text"><label>Customer</label></div>
          <div class="col-12 col-sm-8">
            <!-- <input class="form-control" [readOnly]="true" formControlName="customerName" /> -->
            <pos-app-lib-customer-search
              (selectNewCustomer)="selectCustomer($event)"
              customSearchResult="true"
              [selectedCustomerName]="taskDetailForm?.controls?.customerName?.value"
              [disabled]="preSelectedCustomerNumber"
              [showSearchIcon]="true"
              [removeCustomerAfterLoad]="false"
              placeHolder="CUSTOMER SEARCH"
              value="{{ taskDetailForm?.controls?.customerName?.value }}"
              (focus)="isFocus($event)"
            ></pos-app-lib-customer-search>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div *ngIf="newTask" class="d-flex justify-content-center text-danger pb-4">
    [Note: Other Task fields and buttons are only available once you save this task info]
  </div>
  <div class="row p-2 mx-4 justify-content-end border-top">
    <div class="col-6 col-md-2">
      <button class="btn w-100 text-uppercase" [disabled]="taskDetailForm.invalid || !formValid" (click)="saveTask()">
        {{ !formValid && !newTask ? 'Already Saved' : 'Save' }}
      </button>
    </div>
    <div class="col-6 col-md-2">
      <button class="btn btn-cancel w-100 text-uppercase" (click)="cancelForm()">Cancel</button>
    </div>
  </div>
</div>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="modal-title" id="modal-basic-title ">{{ isChangeAssignee ? 'ASSIGN TO' : isChangeOrder ? 'LINK ORDER TO NEW TASK' : '' }}</h3>
  </div>

  <div *ngIf="isChangeAssignee">
    <div class="modal-body">
      <form [formGroup]="changeAssigneeForm">
        <div *ngIf="!isInternalUser || isShowUser" class="row px-4">
          <div class="col-12 col-md-10 pb-1">
            <div class="row pb-1">
              <div class="col-12 col-sm-3 label-text"><label>Select Store Type</label></div>
              <div class="col-12 col-sm-9">
                <input type="radio" formControlName="storeType" value="0" /><span class="px-1"></span>ARB Corporate Stores
                <span class="px-2"></span>
                <input type="radio" formControlName="storeType" value="1" /><span class="px-1"></span>Non-Corporate Stores
              </div>
            </div>
          </div>
          <div class="col-12 col-md-10 pb-1">
            <div class="row pb-1">
              <div class="col-12 col-sm-3 label-text"><label>Select Site</label></div>
              <div class="col-12 col-sm-6">
                <ng-select placeholder="Select Site" formControlName="site" [clearable]="true">
                  <ng-option *ngFor="let site of siteListFiltered" [value]="site.siteCode"
                    >{{ site.siteDescription }} ({{ site.siteCode }})</ng-option
                  >
                </ng-select>
              </div>
              <div class="col-12 col-sm-3 label-text">
                <button (click)="assignToMysite()" class="btn btn-secondary" type="button">SET TASK TO MY SITE</button>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-10 pb-1">
            <div class="row pb-1">
              <div class="col-12 col-sm-3 label-text"><label>Select Assignee</label></div>
              <div class="col-12 col-sm-6">
                <ng-select placeholder="Select Site" formControlName="assignedTo" [clearable]="false">
                  <ng-option *ngFor="let salesperson of salesPersonList" [value]="salesperson.userEmail">{{ salesperson.name }} </ng-option>
                </ng-select>
              </div>
              <div class="col-12 col-sm-3 label-text">
                <button (click)="assignToMe()" class="btn btn-secondary" type="button">ASSIGN TO ME</button>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justifiy-content-center text-danger" style="font-size: 15px">
          [Note: Tasks can be assigned to people within your site or to another site you deal with but tasks cannot be directly assigned to other
          people at other sites.]
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn text-uppercase" [disabled]="changeAssigneeForm.invalid" (click)="changeAssignee()">Update</button>
      <button type="button" class="btn btn-secondary text-uppercase" (click)="cancelModel()">Cancel</button>
    </div>
  </div>
  <div *ngIf="isChangeOrder">
    <div class="modal-body">
      <form [formGroup]="changeOrderForm">
        <div class="row pb-1">
          <div class="col-12 col -sm-4 label-text">Enter Order Number</div>
          <div class="col-12 col-sm-8">
            <input class="form-control" formControlName="newOrderNumber" />
          </div>
        </div>
        <div class="row pb-1">
          <div class="col-12 col -sm-4 label-text">Enter Order Type</div>
          <div class="col-12 col-sm-8">
            <ng-select formControlName="newOrderType" [clearable]="false">
              <ng-option *ngFor="let orderType of orderTypes" [value]="orderType.OrderTypeCode">
                {{ orderType.OrderTypeDescription }}
              </ng-option>
            </ng-select>
          </div>
        </div>
        <div *ngIf="validChangeOrder || linkOrderCustomerName" class="pb-2">
          <div>Customer Name</div>
          <div class="col-12 col-sm-8">
            <input class="form-control" [value]="linkOrderCustomerName" readonly="true" />
          </div>
        </div>
      </form>
      <button
        type="button"
        class="d-flex btn justify-content-start text-uppercase"
        [disabled]="changeOrderForm.invalid"
        (click)="validateForChangeOrder()"
      >
        Validate
      </button>

      <div class="pt-2">
        <div *ngIf="!validChangeOrder" class="text-danger">[Note: Please validate order before you update link order to this task.]</div>
        <div *ngIf="validChangeOrder" class="text-success">[Note: Order details provided is valid, procced to update link order to this task.]</div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn text-uppercase" [disabled]="!taskDetailForm?.controls?.orderNumber?.value" (click)="removeOrderLink()">
        Remove link
      </button>

      <button type="button" class="btn text-uppercase" [disabled]="!validChangeOrder || changeOrderForm.invalid" (click)="changeOrderNumber()">
        Update
      </button>
      <button type="button" class="btn btn-cancel text-uppercase" (click)="cancelModel()">Cancel</button>
    </div>
  </div>
</ng-template>
